import React, { Suspense, Fragment, useState, useEffect } from "react";
import { Route, Switch, useLocation } from "react-router-dom";

// Components and layouts
import AppLayout from "./layout";
import Auth from "./components/Auth";
import { AuthGuard } from "./components/AuthGuard";
import Login from "./views/auth/Login";
import ForgetPassword from "./views/auth/ForgetPassword";
import MyAccount from "./views/account/myAccount";
import Reservations from "./views/Reservations";
import CurrentReservation from "./views/Reservations/currentReservation";
import { TableManagement } from "./views/settings";
import { ManageUsersList } from "./views/users";
import { ManageZcashList } from "./views/zcash";
import { RestaurantList } from "./views/restaurants";
import CustomerManagement from "./views/CustomerManagement";
import { useSelector } from "react-redux";
import MyRestaurant from "./views/settings/components/myRestaurant/myRestaurant";
import EmailTab from "./views/settings/components/email/emailTab";
import UserReservation from "./views/public/userReservation";
import { getTranslation } from "./heplers/translationHelper";


// Routes configuration
const routesConfig = [
  {
    path: "/",
    exact: true,
    component: () => <Login />,
  },
  {
    path: "/public/user-reservation/:customerId/:primaryColor/:secondaryColor",
    exact: true,
    component: () => <UserReservation enableLogo={true} />,
},
{
    path: "/public/user-reservation/:customerId/:primaryColor/:secondaryColor/iframe",
    exact: true,
    component: () => <UserReservation enableLogo={false} />,
},
{
    path: "/public/user-reservation/:customerId/:primaryColor/:secondaryColor/:reservationId",
    exact: true,
    component: () => <UserReservation />,
},
  {
    path: "/login",
    exact: true,
    component: () => <Login />,
  },
  {
    path: "/forget_password",
    exact: true,
    component: () => <ForgetPassword />,
  },
  {
    path: "/account/profile",
    layout: AppLayout,
    guard: AuthGuard,
    roles: ['Admin', 'Customer', 'Manager', 'ZCash', 'Staff'], // Role-based guard
    component: () => <MyAccount />,
  },
  {
    path: "/admin",
    layout: AppLayout,
    guard: AuthGuard,
    roles: ['Admin'], // Role-based guard
    childrens: [
      {
        path: "/admin",
        exact: true,
        component: () => <RestaurantList />,
      },
   
       {
          path: "/admin/restaurants",
          exact: true,
          component: () => <RestaurantList />,
        },
        // {
        //   path: "/admin/settings",
        //   exact: true,
        //   component: () => <TableManagement />,
        //   // childrens: [
        //   //   {
        //   //     path: "/manager/settings/table-management/myRestaurant",
        //   //     component: () => <MyRestaurant />,
  
        //   //   },
        //   // ],
        // },
        {
          path: "/admin/settings/table-management/:tab",
          exact: true,
          component: () => <EmailTab />,
      },
  
    ]
  },
  {
    path: "/customer",
    layout: AppLayout,
    guard: AuthGuard,
    roles: ['Customer'], // Role-based guard
    childrens: [
      {
        path: "/customer",
        exact: true,
        component: () => <Reservations />,
      },
      {
        path: "/customer/customers",
        exact: true,
        component: () => <CustomerManagement />,
      },
      {
        path: "/customer/reservations",
        exact: true,
        component: () => <Reservations />,
      },
      {
        path: "/customer/users/list",
        exact: true,
        component: () => <ManageUsersList />,
      },
      {
        path: "/customer/dashboard",
        exact: true,
        component: () => <CurrentReservation />,
      },
      {
        path: "/customer/settings/:tab",
        exact: true,
        component: () => <TableManagement />,
    },
      {
        path: "/customer/zcash",
        exact: true,
        component: () => <ManageZcashList />,
        roles: ['Manager', 'ZCash', 'Guest'],
      },
      {
        path: "/customer/settings",
        exact: true,
        component: () => <TableManagement />,
      },     
    ]
  },
  {
    path: "/manager",
    layout: AppLayout,
    guard: AuthGuard,
    roles: ['Manager'], // Role-based guard
    childrens: [
      // {
      //   path: "/manager/reservations",
      //   exact: true,
      //   component: () => <Reservations />,
      // },
      {
        path: "/manager",
        exact: true,
        component: () => <CurrentReservation />,
      },
      {
        path: "/manager/users/list",
        exact: true,
        component: () => <ManageUsersList />,
      },
      {
        path: "/manager/dashboard",
        exact: true,
        component: () => <CurrentReservation />,
      },
      {
        path: "/manager/settings",
        exact: true,
        component: () => <TableManagement />,
        // childrens: [
        //   {
        //     path: "/manager/settings/table-management/myRestaurant",
        //     component: () => <MyRestaurant />,

        //   },
        // ],
      },
      {
        path: "/manager/customers",
        exact: true,
        component: () => <CustomerManagement />,
      },
      {
        path: "/manager/settings/:tab",
        exact: true,
        component: () => <TableManagement />,
    },
      {
        path: "/manager/zcash",
        exact: true,
        component: () => <ManageZcashList />,
      },
     
      {
        path: "*",
        component: () => <>{getTranslation("Not Found")}</>
      }
    ]
  },
  {
    path: "/staff",
    layout: AppLayout,
    guard: AuthGuard,
    roles: ['Staff'], // Role-based guard
    childrens: [
      {
        path: "/staff",
        exact: true,
        component: () => <Reservations />,
      },
      {
        path: "/staff/customers",
        exact: true,
        component: () => <CustomerManagement />,
      },
      {
        path: "/staff/Dashboard",
        exact: true,
        component: () => <Reservations />,
      },
      {
        path: "/staff/reservations",
        exact: true,
        component: () => <Reservations />,
      },
      {
        path: "*",
        component: () => <>{getTranslation("Not Found")}</>
      }
    ]
  },
  {
    path: "/zcash",
    layout: AppLayout,
    guard: AuthGuard,
    roles: ['ZCash'], // Role-based guard
    childrens: [
      {
        path: "/zcash",
        exact: true,
        component: () => <ManageZcashList />,
      },
      {
        path: "/zcash/customers",
        exact: true,
        component: () => <CustomerManagement />,
      },
      {
        path: "/zcash/dashboard",
        exact: true,
        component: () => <CurrentReservation />,
      },
     
      {
        path: "*",
        component: () => <>{getTranslation("Not Found")}</>
      }
    ]
  },

  // {
  //   path: "/manager",
  //   layout: AppLayout,
  //   guard: (props) => <AuthGuard roles={['Manager']} {...props} />, // Role-based guard
  //   childrens: [
  //     {
  //       path: "",
  //       exact: true,
  //       component: () => <CurrentReservation />,

  //     },

  // {
  //   path: "/settings/table-management",
  //   exact: true,
  //   component: () => <TableManagement />,
  //   roles: ['Admin'],
  // },
  // {
  //   path: "/dashboard",
  //   exact: true,
  //   component: () => <CurrentReservation />,
  //   roles: ['Admin', 'Manager', 'Staff', 'Guest','owner'],
  // },
  // {
  //   path: "/reservations",
  //   exact: true,
  //   component: () => <Reservations />,
  //   roles: ['Admin', 'Manager', 'Staff', 'Customer', 'Guest','owner'],
  // },

  // {
  //   path: "/users/list",
  //   exact: true,
  //   component: () => <ManageUsersList />,
  //   roles: ['Manager', 'Customer', 'Guest','owner'],
  // },
  // {
  //   path: "/zcash",
  //   exact: true,
  //   component: () => <ManageZcashList />,
  //   roles: ['Manager', 'ZCash', 'Guest'],
  // },
  // {
  //   path: "/restaurants",
  //   exact: true,
  //   component: () => <RestaurantList />,
  //   roles: ['Admin', 'Guest'],
  // },
  // {
  //  path: "/settings",
  //  exact: true,
  // component: () => <TableManagement />,
  // },
  // {
  //  path: "/settings/table",
  //  exact: true,
  // component: () => <ReservationsSettings />,
  //  },
  //       {
  //         component: () => <div>Not Found</div>,
  //       },
  //     ],
  //   },
  //   {
  //     component: () => <div>Not Found</div>,
  //   },
  {
    path: "*",
    component: () => <>{getTranslation("Not Found")}</>
  }
];

// Render routes function
const renderRoutes = (routes) => {
  return routes ? (
    <Suspense fallback={<h1>{getTranslation("loading...")}</h1>}>
      <Switch>
        {routes.map((route, i) => {
          const Guard = route.guard || Fragment;
          const Layout = route.layout || Fragment;
          const Component = route.component;



          return (
            <Route
              exact={route.exact}
              path={route.path}
              key={i}
              render={(props) => (
                <Layout>
                  <Guard roles={route.roles}>
                    {route.childrens ? (
                      renderRoutes(route.childrens)
                    ) : (
                      <Component {...props} />
                    )}
                  </Guard>
                </Layout>
              )}
            />
          );
        })}
      </Switch>
    </Suspense>
  ) : null;
};

// AppRoutes component
const AppRoutes = () => {
  return renderRoutes(routesConfig);
};
export default AppRoutes;